import { jsonReviver } from "../../../utils";

/*
  `standardSpecificIssuanceData` arrives from the issuance query as a JSON string (dates included) but is
  already an object once a caller has parsed it, so every reader has to normalise it before looking fields up.
  `jsonReviver` revives the date strings, which is what lets the readers format them as dates.
*/
export const parseStandardSpecificIssuanceData = (standardSpecificIssuanceData: unknown): Record<string, unknown> => {
  if (standardSpecificIssuanceData == null) return {};

  if (typeof standardSpecificIssuanceData === "string") {
    try {
      const parsedData = JSON.parse(standardSpecificIssuanceData, jsonReviver) as unknown;

      return parsedData !== null && typeof parsedData === "object" ? (parsedData as Record<string, unknown>) : {};
    } catch {
      return {};
    }
  }

  return typeof standardSpecificIssuanceData === "object"
    ? (standardSpecificIssuanceData as Record<string, unknown>)
    : {};
};
